import { type UserEntity, UserType } from "@/shared/types/user.entity";

/** INTERNAL staff always; a member once staff enabled batch payouts for their organization. */
export function canReachPayoutBatches(user: UserEntity | null | undefined): boolean {
  if (!user) return false;
  return user.user_type === UserType.INTERNAL || user.organization?.payout_batches_enabled === true;
}
